import { render, staticRenderFns } from "./OrdersPerStatus.vue?vue&type=template&id=ea37ecda"
import script from "./OrdersPerStatus.vue?vue&type=script&lang=js"
export * from "./OrdersPerStatus.vue?vue&type=script&lang=js"
import style0 from "./OrdersPerStatus.vue?vue&type=style&index=0&id=ea37ecda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports